import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { NewFlowForDatasource } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface NewFlowForDatasourceAction extends Action {
  contentInfo: IContentInfo;
}

export function newFlowForDatasource(contentInfo: IContentInfo): NewFlowForDatasourceAction {
  return {
    type: NewFlowForDatasource,
    contentInfo
  };
}

export const isNewFlowForDatasourceAction = isActionFactory<NewFlowForDatasourceAction>(NewFlowForDatasource);
